var _defs, _path, _path2, _circle, _path3, _circle2, _path4, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntellectual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emotional",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #323131;\n        stroke-linejoin: round;\n        stroke-width: 10px;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.732,322.235s77.64-66.862-11.861-128.332c0,0,16.175-55-49.6-81.96,0,0-14.019-62.548-52.839-70.1,0,0-64.7-22.647-60.386,47.451l-1.078,167.155s-4.314,10.785-11.862,0l-1.078-176.86S251.38,28.4,200.761,39.6q-2.257.5-4.653,1.167c-55.354,15.457-53.2,59.314-52.838,71.176,0,0-45.29,5.392-50.682,22.647,0,0-21.207,14.379-14.018,56.078,0,0-25.161,11.143-33.428,50.686,0,0-10.424,40.98,32.35,67.94l11.862,14.019s-8.627,25.164,7.548,47.451,27.677,20.49,45.289,31.274c0,0-3.594,34.689,30.194,59.313,0,0,6.829,12.043,49.6,11.863,0,0,24.442-.539,28.037-39.9V284.49s6.11-9.346,14.018,0l1.078,136.96s-5.391,44.215,28.037,52.842c0,0,61.824,12.582,84.11-69.019l2.156-7.549,17.253-2.156s29.834-8.987,38.82-38.823Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.1,150.7s16.488-2.736,16.488-14.228c0,0,1.1-6.02-4.4-14.229,0,0,1.1-6.567,6.595-2.189,0,0,15.939,11.493,23.084-5.472l3.3-7.662s5.5-6.019,6.595,3.284c0,0,.733,13.5,15.389,13.134,0,0,13.923-2.919,10.992-4.378,0,0,6.229-2.919,5.5,4.378,0,0-9.16,7.661-3.3,19.7a20.44,20.44,0,0,0,15.389,7.661s4.03,3.284-2.2,6.567c0,0-11.725-.365-14.29,13.134,0,0-1.465,10.58,4.4,13.134,0,0,1.466,7.662-6.595,4.378,0,0-8.427-7.661-18.687-2.189,0,0-8.427,6.2-7.694,15.323,0,0-1.832,2.189-6.595,0,0,0,1.466-14.593-10.992-16.417,0,0-12.458-2.554-15.389,4.378,0,0-7.694-.73-4.4-6.567,0,0,4.763-4.743,3.3-13.134,0,0-1.1-12.4-14.289-12.04,0,0-2.565-.729-3.3-4.378Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 185.5,
    cy: 153.5,
    r: 10.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_copy",
    "data-name": "Shape 2 copy",
    className: "cls-2",
    d: "M79.1,260.7s16.488-2.736,16.488-14.228c0,0,1.1-6.02-4.4-14.229,0,0,1.1-6.567,6.6-2.189,0,0,15.939,11.493,23.084-5.472l3.3-7.662s5.5-6.019,6.595,3.284c0,0,.733,13.5,15.389,13.134,0,0,13.923-2.919,10.992-4.378,0,0,6.229-2.919,5.5,4.378,0,0-9.16,7.661-3.3,19.7a20.44,20.44,0,0,0,15.389,7.661s4.03,3.284-2.2,6.567c0,0-11.725-.365-14.29,13.134,0,0-1.465,10.58,4.4,13.134,0,0,1.466,7.662-6.595,4.378,0,0-8.427-7.661-18.687-2.189,0,0-8.427,6.2-7.694,15.323,0,0-1.832,2.189-6.6,0,0,0,1.466-14.593-10.992-16.417,0,0-12.457-2.554-15.389,4.378,0,0-7.694-.73-4.4-6.567,0,0,4.763-4.743,3.3-13.134,0,0-1.1-12.405-14.29-12.04,0,0-2.565-.729-3.3-4.378Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy",
    "data-name": "Ellipse 1 copy",
    className: "cls-3",
    cx: 125.5,
    cy: 263.5,
    r: 10.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_copy_2",
    "data-name": "Shape 2 copy 2",
    className: "cls-2",
    d: "M139.1,365.7s16.488-2.736,16.488-14.228c0,0,1.1-6.02-4.4-14.229,0,0,1.1-6.567,6.595-2.189,0,0,15.939,11.493,23.084-5.472l3.3-7.662s5.5-6.019,6.595,3.284c0,0,.733,13.5,15.389,13.134,0,0,13.923-2.919,10.992-4.378,0,0,6.229-2.919,5.5,4.378,0,0-9.16,7.661-3.3,19.7a20.44,20.44,0,0,0,15.389,7.661s4.03,3.284-2.2,6.567c0,0-11.725-.365-14.29,13.134,0,0-1.465,10.58,4.4,13.134,0,0,1.466,7.662-6.595,4.378,0,0-8.427-7.661-18.687-2.189,0,0-8.427,6.2-7.694,15.323,0,0-1.832,2.189-6.595,0,0,0,1.466-14.593-10.992-16.417,0,0-12.458-2.554-15.389,4.378,0,0-7.694-.73-4.4-6.567,0,0,4.763-4.743,3.3-13.134,0,0-1.1-12.405-14.289-12.04,0,0-2.565-.729-3.3-4.378Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_2",
    "data-name": "Ellipse 1 copy 2",
    className: "cls-3",
    cx: 185.5,
    cy: 368.5,
    r: 10.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_3",
    "data-name": "Ellipse 1 copy 3",
    className: "cls-3",
    cx: 225.5,
    cy: 235.5,
    r: 10.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_4",
    "data-name": "Ellipse 1 copy 4",
    className: "cls-3",
    cx: 225.5,
    cy: 285.5,
    r: 10.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellectual);
export default __webpack_public_path__ + "static/media/intellectual.df2881f364ad7a46c22158fdd4cf95be.svg";
export { ForwardRef as ReactComponent };